import { useEffect } from 'react';
import { runUnlessSigningOut } from 'components/core/WithLogout/model';
import { dataFlushClient } from 'shared/domain/dataFlush/dataFlushClient';

/** Reloads after the worker dropped stored data (all of it or the project's), unless this tab is signing out. */
export function useReloadAfterDataFlush(reload: () => void): void {
  useEffect(() => {
    const reloadAfterFlush = runUnlessSigningOut(reload);
    const stopListeningToDataFlushes = dataFlushClient.onDataFlushed(reloadAfterFlush);
    const stopListeningToProjectFlushes = dataFlushClient.onProjectDataFlushed(reloadAfterFlush);
    return (): void => {
      stopListeningToDataFlushes();
      stopListeningToProjectFlushes();
    };
  }, [reload]);
}
